'use strict';
import {AppController} from './AppController';
import {MainMenu} from './components/MainMenu';
import {MainMenuController} from './MainMenuController';
import {$modelProvider} from './model/AppModel';
import {AppNavigationAssetProjects} from './navigation/components/AppNavigationAssetProjects';
// eslint-disable-next-line max-len
import {injector as AppNavigationAssetProjectsContainerInjector} from './navigation/components/AppNavigationAssetProjects/AppNavigationAssetProjectsContainer';
import {AppNavigationAssets} from './navigation/components/AppNavigationAssets';
import {AppNavigationOrgs} from './navigation/components/AppNavigationOrgs';
import {AppNavigationProjects} from './navigation/components/AppNavigationProjects';
import {routerConfig} from './router';
import LogRocket from 'logrocket';
LogRocket.init('wolzne/swift-projects');

const angular = require('angular');

module.exports = angular
  .module('app.app', [])
  .config(routerConfig)
  .provider('$model', $modelProvider)

  .constant('AppNavigationAssetProjects', AppNavigationAssetProjects)
  .constant('AppNavigationAssets', AppNavigationAssets)
  .constant('AppNavigationOrgs', AppNavigationOrgs)
  .constant('AppNavigationProjects', AppNavigationProjects)

  .run(AppNavigationAssetProjectsContainerInjector)
  .controller('AppController', AppController)
  .controller('MainMenuController', MainMenuController)
  .controller('DummyController', require('./DummyController.js'))
  .directive('mainMenu', ['reactDirective', reactDirective => reactDirective(MainMenu)])
;



// WEBPACK FOOTER //
// ./src/js/app/index.js